import {toast} from 'sonner';
import type {ReactNode} from 'react';
import {getErrorMessage} from './utils/miscUtils';
export interface AppToast {
  severity?: 'error' | 'info' | 'success' | 'warn' | 'warning';
  summary?: ReactNode;
  detail?: ReactNode;
  life?: number;
  sticky?: boolean;
}
export const toastError = (error: unknown) => toast.error('Error', {description: getErrorMessage(error)});
export const toastInfo = (message: string) => toast.info('Info', {description: message});
export const toastSuccess = (message: string) => toast.success('Success', {description: message});
export const toastWarning = (message: string) => toast.warning('Warning', {description: message});
export const toastShow = ({severity = 'info', summary, detail, life, sticky}: AppToast) =>
  toast[severity === 'warn' ? 'warning' : severity](summary, {description: detail, duration: sticky ? Infinity : life});
